export const getLayerSpacing = buttonWidth => buttonWidth * 0.15



// WEBPACK FOOTER //
// ./src/node_modules/components/functions/getLayerSpacing.js